import React from 'react';
import { fr } from '../i18n/fr';

export type PlaybackMode = 'LIVE' | 'VOD' | 'AD' | 'RADIO';

export interface ModeIndicatorProps {
  mode: PlaybackMode;
}

/**
 * Mode indicator displayed in the bottom-left corner.
 * Shows current state: LIVE, VOD, or AD (Req 1.5).
 */
export const ModeIndicator: React.FC<ModeIndicatorProps> = ({ mode }) => {
  const label = getLabel(mode);
  const color = getColor(mode);

  return (
    <div
      style={{ ...styles.container, backgroundColor: color }}
      role="status"
      aria-live="polite"
      aria-label={`Mode: ${label}`}
    >
      {mode === 'LIVE' && <span style={styles.dot} />}
      <span style={styles.text}>{label}</span>
    </div>
  );
};

function getLabel(mode: PlaybackMode): string {
  switch (mode) {
    case 'LIVE':
      return fr.status.live;
    case 'VOD':
      return fr.status.vod;
    case 'AD':
      return fr.status.ad;
    case 'RADIO':
      return fr.status.radio;
  }
}

function getColor(mode: PlaybackMode): string {
  switch (mode) {
    case 'LIVE':
      return '#cc0000';
    case 'VOD':
      return '#006B2B';
    case 'AD':
      return '#002776';
    case 'RADIO':
      return '#5C2D91';
  }
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '4px 10px',
    borderRadius: '4px',
    fontSize: '0.75rem',
    fontWeight: 700,
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
  },
  dot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: '#ffffff',
    animation: 'pulse 1.5s infinite',
  },
  text: {
    color: '#ffffff',
  },
};
